export interface IFlatViewOrderInfo {
  /** Доступна ли запись? **/
  isEnabled: boolean;
  /** Статус записи **/
  orderStatus: IOrderStatus;
}

export interface IOrderStatus {
  /** Сообщение в банере **/
  description?: string | null;
  /** Статус записи **/
  type: EOrderStatusType;
}

export enum EOrderStatusType {
  /**  **/
  NoActive = 'noActive',
  /**  **/
  SignedUp = 'signedUp',
}
